import React from 'react';

import { ReactComponent as PowerMeterSVG } from './power-meter.svg';

function FarmbotPowerMeterIcon() {
  return <PowerMeterSVG width={18} />;
}

export default FarmbotPowerMeterIcon;
